import {ResourceActionPermissionExpressionResponseBody} from '@dms/api/security';
import {ActionPermission} from '@dms/api/shared';

export const findUserAction =
  (requestedPermission: ActionPermission) =>
  (action: ResourceActionPermissionExpressionResponseBody) =>
    action.actionId === requestedPermission.actionId &&
    action.resourceId === requestedPermission.resourceId;
